import { v4 as uuid } from "uuid";
import { getDownloadURL, uploadBytes } from "firebase/storage";
import { ref, storage } from "../firebase/firebase-config";

const KYB_MIME = {
  "image/jpeg": "jpeg",
  "image/jpg": "jpg",
  "image/png": "png",
  "application/pdf": "pdf",
};

const KYB_EXT = {
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  png: "image/png",
  pdf: "application/pdf",
};

export const MAX_KYB_BYTES = 5 * 1024 * 1024;

export const kybFileMeta = (file) => {
  const fromType = KYB_MIME[file.type];
  const fromName = `${file.name || ""}`.split(".").pop()?.toLowerCase();
  const ext = fromType || (KYB_EXT[fromName] ? fromName : "");
  if (!ext) return null;
  return { ext, contentType: KYB_EXT[ext] };
};

export const uploadKybFile = (file, docType) => {
  const meta = kybFileMeta(file);
  if (!meta) {
    return Promise.reject(new Error("Upload a JPEG, PNG, or PDF file"));
  }
  if (file.size > MAX_KYB_BYTES) {
    return Promise.reject(new Error("Each KYB document must be 5MB or smaller"));
  }

  const storageRef = ref(
    storage,
    `id_docs/${uuid()}_${docType}.${meta.ext}`
  );
  return uploadBytes(storageRef, file, { contentType: meta.contentType }).then(
    () => getDownloadURL(storageRef)
  );
};
